import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../hooks";

const ProtectedRoute = ({ user, children, route_permissions }) => {
  const { hasRequiredPermissions } = usePermissions();
  if (user && user?.uid) {
    if (!hasRequiredPermissions(user, route_permissions)) {
      return (
        <Navigate
          to="/dashboard"
          replace
        />
      );
    }
    return children;
  }

  return (
    <Navigate
      to="/login"
      replace
    />
  );
};

export default ProtectedRoute;
